<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="sidebarx"
    spacer
    v-model="updateBirthConfig.isOpen"
    id="update-birthday"
  >
    <div class=" flex items-center justify-between px-6">
      <h4 class="text-2xl font-bold">Edit Birthday Campaign Info</h4>
      <feather-icon icon="XIcon" @click.stop="closeUpdateBirth" class="cursor-pointer mt-4"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
      <div class="sidebar-content p-6 scroll">
        <div class="info-form"
        data-aos="fade-up"
        data-aos-offset="200"
        data-aos-delay="10"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        data-aos-once="false"
        data-aos-anchor-placement="top-center"
        >
            <h4 class="text-lg font-bold">What is your birthday offer name?</h4>
            <div class="centerx labelx">
              <vs-input v-model="birthday_name" class="w-full birthday-name" :maxlength="50" v-validate="'required'" name="birthday_name" :danger="errors.has('birthday_name')"
              danger-text="The birthday name field is required"/>
            </div>
            <h4 class="text-lg font-bold">What is the value of promotion?</h4>
            <div class="w-row">
              <ul class="centerx flex align-center justify-between">
                <vs-input-number min="0" :max="max" v-model="birthday_logic_value" :key="abc" class="w-7/12"/>
                 <li @click="max=100,abc++">
                  <vs-radio v-model="birthday_logic_type" vs-value="percent" class="flex align-center m-0">%</vs-radio>
                </li>
                <li @click="max=999,abc++" class="mr-base">
                  <vs-radio v-model="birthday_logic_type" vs-value="usd" class="flex align-center m-0">$</vs-radio>
                </li>
              </ul>
            </div>
            <h4 class="text-lg leading-normal font-bold">How many days before your customer's birthday do you want to send this promotion?</h4>
            <v-select id="before-choice" label="text" v-validate="'required'" name="birthday_before_date" v-model="birthday_before_date" :options="before_choices" class="w-7/12" :clearable="false" :searchable="false" :class="{'invalid-border': errors.has('birthday_before_date')}"></v-select>
            <span class="text-danger text-xs error-text-input span-text-validation hide-error mt-3" :class="{'show-error': errors.has('birthday_before_date')}">This field is required</span>

            <h4 class="text-lg leading-normal font-bold">How many days after your customer's birthday do you want to available this promotion?</h4>
            <v-select id="after-choice" label="text" v-validate="'required'" name="birthday_expired_day_in" v-model="birthday_expired_day_in" :options="after_choices" class="w-7/12" :clearable="false" :searchable="false" :class="{'invalid-border': errors.has('birthday_expired_day_in')}"></v-select>
            <span class="text-danger text-xs error-text-input span-text-validation hide-error mt-3" :class="{'show-error': errors.has('birthday_expired_day_in')}">This field is required</span>

            <h4 class="text-lg font-bold">Message to show to customer</h4>
             <vs-textarea v-model="birthday_content" counter="140" :counter-danger.sync="counterDanger" height="150" />
            <h4 class="text-lg font-bold">Change Status</h4>
            <ul class="switch-container mb-base">
               <li>
                <vs-switch v-model="birthday_active" @click.stop="switchActive"/>
              </li>
            </ul>
          </div>
        </div>
      </VuePerfectScrollbar>
    <div class="flex flex-wrap items-center p-6 justify-center" slot="footer">
      <vs-button class="mr-6" @click.stop="updateBirthday" style="min-width: 140px;">Submit</vs-button>
      <vs-button type="border" color="danger" @click.stop="closeUpdateBirth" style="min-width: 140px;">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'

export default {
  name: "vs-update-birth",
  components: {
    SideBarItem: () => import("../../components/SideBarItem.vue"),
    flatPickr,
    VuePerfectScrollbar,
    'v-select': vSelect,
  },
  props: {
    updateBirthConfig: {
      type: Object,
      required: true
    },
    sidebarData: {
      type: Object,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    itemsPerPage: {
      type: Number,
      required: true
    }
  },
  data() {
      return {
          name: this.sidebarData.campaign.name,
          logic_value: this.sidebarData.campaign.logic_value,
          logic_type: this.sidebarData.campaign.logic_type,
          before_date: {text: this.sidebarData.birthday_campaign.before_date + ' days', value:this.sidebarData.birthday_campaign.before_date},
          expired_day_in: {text: this.sidebarData.campaign.expired_day_in + ' days', value:this.sidebarData.campaign.expired_day_in},
          content: this.sidebarData.birthday_campaign.content,
          is_active: this.sidebarData.campaign.is_active,
          counterDanger: false,

          before_choices: [
            {text:'3 days',value:'3'},
            {text:'7 days',value:'7'},
            {text:'15 days',value:'15'},
            {text:'30 days',value:'30'}
          ],

          after_choices: [
            {text:'On their birthday' , value: '0'},
            {text:'1 days',value:'1'},
            {text:'3 days',value:'3'},
            {text:'5 days',value:'5'},
            {text:'7 days',value:'7'},
            {text:'14 days',value:'14'},
          ],

          settings: { // perfectscrollbar settings
            maxScrollbarLength: 60,
            wheelSpeed: .60,
          },
          max: 100,
          abc: 0,
      }
  },
  watch: {
    updateBirthConfig: {
      immediate: true,
      deep: true,
      handler() {
        this.name = this.sidebarData.campaign.name;
        this.content = this.sidebarData.birthday_campaign.content;
        this.is_active = this.sidebarData.campaign.is_active;
        this.logic_value = this.sidebarData.campaign.logic_value;
        this.before_date = {text: this.sidebarData.birthday_campaign.before_date + ' days', value:this.sidebarData.birthday_campaign.before_date};
        if(this.sidebarData.campaign.expired_day_in == 0){
          this.expired_day_in = {text: 'On their birthday', value:this.sidebarData.campaign.expired_day_in}
        }else{
          this.expired_day_in = {text: this.sidebarData.campaign.expired_day_in + ' days', value:this.sidebarData.campaign.expired_day_in}
        }
        this.errors.clear();
        if(this.updateBirthConfig.isOpen) {
          this.logic_type = this.sidebarData.campaign.logic_type;
          if(this.logic_type == 'usd'){
            this.max = 999;
          }else {
            this.max = 100;
          }
          document.body.classList.add('overflow-hidden');
        } else {
          document.body.classList.remove('overflow-hidden');
        }
      }
    },
    max: {
      immediate: true,
      deep: true,
      handler(val) {
        if(this.birthday_logic_value > val) {
          this.birthday_logic_value = val;
        }
      }
    }
  },
  computed: {
      id:{
        get(){return this.sidebarData.campaign.id},
        set(){}
      },
      birthday_name: {
          get() { return  this.name; },
          set(value) {
            this.name = value;
           }
      },
      birthday_logic_value:{
        get() {return this.logic_value},
        set(value) {
          this.logic_value = value;
        }
      },
      birthday_logic_type:{
        get(){return this.logic_type},
        set(value){
          this.logic_type = value;
        }
      },
      birthday_before_date:{
        get(){return this.before_date},
        set(value){
          this.before_date = value;
        }
      },
      birthday_expired_day_in:{
        get(){return this.expired_day_in},
        set(value){
          this.expired_day_in = value;
        }
      },
      birthday_content:{
        get(){
          return this.content;
        },
        set(value){
          this.content = value;
        }
      },
      birthday_active:{
        get(){return this.is_active;},
        set(value){
          this.is_active = value;
        }
      }
  },
  methods: {
    switchActive(){
      this.is_active = this.is_active;
    },
    closeUpdateBirth() {
      this.$emit("CloseUpdateBirth");
    },
    updateBirthday(){
      if(this.name != "" && this.before_date != null && this.expired_day_in != null) {
        const obj = {
          id: this.id,
          name: this.name,
          content: this.content,
          is_active: this.is_active ? 1 : 0,
          logic_value: this.logic_value,
          logic_type: this.logic_type,
          before_date: this.before_date.value,
          expired_day_in: this.expired_day_in.value,
          page: this.currentPage,
         'per-page': this.itemsPerPage
        };
        this.$emit("UpdateBirthday" ,obj);
        this.closeUpdateBirth();
      }
      this.$validator.validateAll();
    }
  }
};
</script>
